import * as Common from '@tfo/common'
import RootStore from './RootStore'
import { observable, action } from 'mobx'
import { validate } from '../utils/validation'
import $http from '../utils/$http'

interface ErrorState {
	password: boolean
	repeatPassword: boolean
}

const validators = {
	password: ['password'],
	repeatPassword: ['password'],
}

export class CreatePasswordController {
	@observable public password: string = ''
	@observable public repeatPassword: string = ''
	@observable public rootStore: RootStore
	@observable public loading: boolean = false
	@observable public tokenError: boolean = false
	@observable public errorModel: Common.models.ErrorModel<ErrorState>

	constructor(rootStore: RootStore) {
		this.rootStore = rootStore
		this.errorModel = new Common.models.ErrorModel({
			password: false,
			repeatPassword: false,
		})
	}

	@action public onChange(key: string, value: string) {
		this[key] = value
	}

	@action public async onBlur(
		key: string,
		value: string | boolean,
	): Promise<void> {
		if (key === 'repeatPassword') {
			await this.errorModel.onChange(key, this.repeatPassword !== this.password)
		}
		await this.errorModel.onChange(key, !validate(value, validators[key]))
	}

	@action public async onCreatePassword(createToken: any, newPassword: string) {
		this.loading = true

		return await $http.post<any>(`/user/password/reset`, { token: createToken.token, newPassword: newPassword })
			.then(response => {
				this.login(response)
			})
			.catch(() => {
				this.tokenError = true
				this.loading = false
			})
	}

	@action private login = (customerLogin) => {
        Common.utils.setCookie(JSON.stringify(customerLogin))		
        this.rootStore.login()
            .then(() => {
				window.location.href = '/start'
				this.loading = false
			}
            ).catch(console.error)
	}
}
